import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Plus, Trash2 } from 'lucide-react';
import SiteFields, { emptySite } from './SiteFields';

export const blankSite = emptySite;

export const siteLabel = (s) => [s.name, s.lsd || s.address].filter(Boolean).join(' — ') || 'Unnamed site';

// Editable list of sites used by the customer add/edit dialog.
export default function SitesEditor({ value = [], onChange, testPrefix = 'customer-site' }) {
  const rows = value;
  return (
    <div className="space-y-3" data-testid={`${testPrefix}-editor`}>
      <div className="flex items-center justify-between">
        <Label>Sites</Label>
        <Button type="button" size="sm" variant="outline" onClick={() => onChange([...rows, emptySite()])} data-testid={`${testPrefix}-add-row-btn`}>
          <Plus size={13} className="mr-1.5" /> Add Site
        </Button>
      </div>
      {rows.length === 0 && <p className="text-xs text-slate-500" data-testid={`${testPrefix}-empty`}>No sites recorded yet.</p>}
      {rows.map((r, idx) => (
        <div key={r.id} className="relative rounded-md border border-slate-200 p-3 pr-9" data-testid={`${testPrefix}-row-${idx}`}>
          <SiteFields compact value={r} onChange={(next) => onChange(rows.map((x) => (x.id === r.id ? next : x)))} testPrefix={`${testPrefix}-${idx}`} />
          <button type="button" onClick={() => onChange(rows.filter((x) => x.id !== r.id))} className="absolute top-2 right-2 text-slate-400 hover:text-red-600 p-1" aria-label="Remove site" data-testid={`${testPrefix}-remove-${idx}`}>
            <Trash2 size={15} />
          </button>
        </div>
      ))}
    </div>
  );
}
